<ng-container
  *ngIf="
    orderHeader?.orderType === 'VS' && orderHeader?.displayOrderStatus;
    else standardOrderStatuses
  "
>
  <ion-item
    lines="none"
    [class]="displayOrderStatusClass()"
    data-cy="order-info-status-text"
  >
    <ion-icon
      slot="start"
      [color]="displayOrderStatusColor()"
      src="{{ icon }}"
    ></ion-icon>
    <ion-label slot="start">
      {{ orderStatusDetails?.translationKey | translate }}
    </ion-label>
  </ion-item>
</ng-container>

<ng-template #standardOrderStatuses>
  <div
    *ngIf="
      orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS' &&
      title !== 'Delivered'
    "
    class="left-align-column"
  >
    <!-- desktop -->
    <div
      id="desktop"
      *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
    >
      <ion-icon
        class="submitted-with-exception"
        color="danger"
        src="assets/icon/submitted-w-exceptions.svg"
        height="32"
        width="auto"
      ></ion-icon>
      <p data-cy="order-page-status-label">
        <ng-container *ngIf="title === 'Transmitted w/ Exceptions'">
          <strong>{{ 'i18n.orderPage.transmitted' | translate }}</strong>
        </ng-container>
        <ng-container *ngIf="title !== 'Transmitted w/ Exceptions'">
          <strong>{{ 'i18n.orderPage.submitted' | translate }}</strong>
        </ng-container>
        {{ 'i18n.orderPage.wExceptions' | translate }}
      </p>
      <!-- <p data-cy="order-page-status-label">
      <strong>{{ 'i18n.orderSubmittedPage.wExceptions' | translate }}</strong>
    </p> -->
    </div>

    <!-- touch -->
    <div *ngIf="(this.platformService?.isTouchExperience$ | async) === true">
      <ion-icon
        class="submitted-with-exception"
        color="danger"
        src="assets/icon/submitted-w-exceptions.svg"
        height="32"
        width="auto"
      ></ion-icon>
      <p data-cy="order-page-status-label">
        <ng-container *ngIf="title === 'Transmitted w/ Exceptions'">
          <strong>{{ 'i18n.orderPage.transmitted' | translate }}</strong>
        </ng-container>
        <ng-container *ngIf="title !== 'Transmitted w/ Exceptions'">
          <strong>{{ 'i18n.orderPage.submitted' | translate }}</strong>
        </ng-container>
        {{ 'i18n.orderPage.wExceptions' | translate }}
      </p>
    </div>
  </div>

  <ion-item
    lines="none"
    class="shipped-exception-info-status"
    data-cy="shipped-exception-info-status-text"
    *ngIf="
      orderHeader?.orderStatus === 'SHIPPED_WITH_EXCEPTIONS' &&
      title !== 'Delivered' &&
      orderStatusDetails !== orderStatusDetailsEnum.DELIVERED
    "
  >
    <ion-icon
      slot="start"
      class="submitted-with-exception"
      color="danger"
      src="assets/icon/shipped-w-exceptions.svg"
      height="32"
      width="auto"
    ></ion-icon>
    <ion-label slot="start">{{
      (orderStatusDetails?.translationKey | translate) || title
    }}</ion-label>
  </ion-item>

  <ng-container *ngIf="orderHeader?.orderDelivered; else nonDeliveredTitle">
    <ion-item
      lines="none"
      class="order-info-status"
      data-cy="order-info-status-text"
    >
      <ion-icon slot="start" color="primary" src="{{ icon }}"></ion-icon>
      <ion-label slot="start" translate>
        {{ 'i18n.orderSubmittedPage.delivered' | translate }}
      </ion-label>
    </ion-item>
  </ng-container>

  <ng-template #nonDeliveredTitle>
    <ion-item
      lines="none"
      class="order-info-status"
      data-cy="order-info-status-text"
      *ngIf="
        orderHeader?.orderStatus !== 'SUBMITTED_WITH_EXCEPTIONS' &&
        orderHeader?.orderStatus !== 'SHIPPED_WITH_EXCEPTIONS' &&
        title !== 'Delivered'
      "
    >
      <ion-icon slot="start" color="primary" src="{{ icon }}"></ion-icon>
      <ion-label slot="start">
        {{ orderStatusDetails?.translationKey | translate }}
      </ion-label>
    </ion-item>
  </ng-template>
</ng-template>
